import React from 'react';
import { getLTVColor, getLTVStatus, formatPercentage } from '../../utils/helpers';
import './ltvbadge.css';

const LtvBadge = ({ ltv, showPercentage = true, size = 'medium' }) => {
  const color = getLTVColor(ltv);
  const status = getLTVStatus(ltv);
  const percentage = formatPercentage(ltv);

  return (
    <div
      className={`jo-xyz-demo-ltv-badge jo-xyz-demo-ltv-badge--${size}`}
      style={{
        backgroundColor: color,
        color: ltv <= 0.5 ? '#FFFFFF' : '#0B1020'
      }}
    >
      <div className="jo-xyz-demo-ltv-badge__content">
        {showPercentage && (
          <span className="jo-xyz-demo-ltv-badge__percentage">
            LTV {percentage}
          </span>
        )}
        <span className="jo-xyz-demo-ltv-badge__status">
          {status}
        </span>
      </div>
    </div>
  );
};

export default LtvBadge;
